/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, TextField, CheckboxGroup } from '@stitch-fix/mode-react';

const HideItemFeedbackForm = ({ feedbackQuestions, bubbleFeedback }) => {
  const [selectedAnswers, setSelectedAnswers] = useState([]);
  const [comments, setComments] = useState('');

  const reasons = feedbackQuestions[0].options.map(question => {
    return { value: question.questionId, label: question.label };
  });

  useEffect(() => {
    const input = {
      reasons: selectedAnswers,
      comments,
    };

    bubbleFeedback(input);
  }, [bubbleFeedback, selectedAnswers, comments]);

  return (
    <Box>
      <CheckboxGroup
        mt={2}
        name="group_vertical"
        direction="vertical"
        value={selectedAnswers}
        onChange={setSelectedAnswers}
        options={reasons}
      />
      <TextField
        name="comments"
        label={feedbackQuestions[1].secondaryLabel}
        value={comments}
        onChange={setComments}
        rows={4}
        mt={2}
      />
    </Box>
  );
};

HideItemFeedbackForm.propTypes = {
  feedbackQuestions: PropTypes.arrayOf(
    PropTypes.shape({
      options: PropTypes.arrayOf(PropTypes.shape({})),
      secondaryLabel: PropTypes.string,
    }),
  ).isRequired,
  bubbleFeedback: PropTypes.func.isRequired,
};

export default HideItemFeedbackForm;
